module.exports = __webpack_public_path__ + "static/media/Call Icon-23-23.7eb40cba.svg";